import accounting from 'accounting';
import Decimal from 'decimal.js-light';

// https://github.com/MikeMcl/decimal.js-light
// http://openexchangerates.github.io/accounting.js/
export default class Price extends Decimal {
  // value, currency, locale
  constructor(value, currency, locale) {
    super(value);
    this.currency =
      currency || (window.config ? window.config.default_currency : 'DKK');
    this.locale = locale || (window.config ? window.config.locale : 'da');
  }

  determineDecimals(decimalPlaces) {
    if (decimalPlaces) return decimalPlaces;
    if (this.decimalPlaces() === 0) return this.decimalPlaces();
    return 2;
  }

  toString(decimalPlaces) {
    const currency_symbols = {
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
      EUR: '€',
    };
    const locale_to_format = {
      da_DK: { thousand: '.', decimal: ',', format: '%v %s' },
      nb_NO: { thousand: ' ', decimal: ',', format: '%s %v' },
      sv_SE: { thousand: ' ', decimal: ',', format: '%v %s' },
      fi_FI: { thousand: ' ', decimal: ',', format: '%v %s' },
      nl_NL: { thousand: '.', decimal: ',', format: '%s %v' },
      de_DE: { thousand: '.', decimal: ',', format: '%v %s' },
      de_AT: { thousand: '.', decimal: ',', format: '%s %v' },
      fr_FR: { thousand: ' ', decimal: ',', format: '%v %s' },
      en_GB: { thousand: ',', decimal: '.', format: '%s%v' },
    };

    const value = this.valueOf();
    const defaults = {
      symbol: currency_symbols[this.currency] || window.config.default_currency,
      // Never change this, whatever the number is it should be displayed
      precision: this.determineDecimals(decimalPlaces),
      decimal: ',',
      thousand: '.',
      format: '%v %s',
    };

    return accounting.formatMoney(value, {
      ...defaults,
      ...locale_to_format[this.locale],
    });
  }
}
